export default "__VITE_ASSET__Bmydt8md__"